import { Alert }                                           from '@/components/ui/alert';
import { Box }                                             from '@chakra-ui/react';
import { Button }                                          from '@/components/ui/button';
import { Center }                                          from '@chakra-ui/react';
import React                                               from 'react';
import { Spinner }                                         from '@chakra-ui/react';
import { Text }                                            from '@chakra-ui/react';
import UserDeletionRequestModel                            from '@/models/services/fondations/UserDeletionRequestModel';
import authStore                                           from '@/stores/authStore';
import { toaster }                                         from '@/components/ui/toaster';
import { useTranslation }                                  from 'react-i18next';
import ApiCollection                                       from '@widesk-core/models/ApiCollection';
import { ModalData }                                       from '@/components/modal/Modal';

interface IPersonalInformationDeletionBoxProps {
	userDeletionRequestCollection: ApiCollection<UserDeletionRequestModel>;
	setModalData: React.Dispatch<React.SetStateAction<ModalData | undefined>>;
	setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const PersonalInformationDeletionBox = (props: IPersonalInformationDeletionBoxProps) => {

	const { userDeletionRequestCollection, setModalData, setModalIsOpen } = props;
	const currentUserUrn = authStore.currentUser.urn;

	const [isSubmitting, setIsSubmitting] = React.useState(false);
	const { t } = useTranslation();

	const activeStatusReferences: UserDeletionRequestStatusReference[] = ['pending', 'processed'];

	const hasRequestWithStatus = (references: UserDeletionRequestStatusReference[]) => userDeletionRequestCollection
		.some(m => m.getUrn('user') === currentUserUrn && references.includes(m.userDeletionRequestStatus.reference));

	const userDeletionRequestIsPending = hasRequestWithStatus(['pending']);
	const hasActiveUserDeletionRequest = hasRequestWithStatus(activeStatusReferences);

	const handleUserDeletionRequest = async () => {

		setModalData({
			isDangerous: true,
			setIsOpen: setModalIsOpen,
			titleComponent: <Text>{t('pages.personalInformation.personalInformationDeletionBox.title')}</Text>,
			bodyComponent: <Text>{t('pages.personalInformation.personalInformationDeletionBox.actions.delete.prompt')}</Text>,
			onClose: () => {
				setModalIsOpen(false);
				setModalData(undefined);
			},
			onConfirm: async () => {
				setIsSubmitting(true);

				await new UserDeletionRequestModel().patch({
					user: authStore.currentUser.urn,
				});
			},
			onError: () => {
				toaster.create({
					title: t('pages.personalInformation.personalInformationDeletionBox.actions.delete.error'),
					type: 'error'
				});
			},
			onSuccess: async () => {
				toaster.create({
					title: t('pages.personalInformation.personalInformationDeletionBox.actions.delete.success'),
					type: 'success'
				});
				await userDeletionRequestCollection.setFilter('user', authStore.currentUser.id).list();
				await userDeletionRequestCollection.whenIsLoaded(m => m.userDeletionRequestStatus);
				setIsSubmitting(false);
				setModalIsOpen(false);
				setModalData(undefined);
			}
		})
		setModalIsOpen(true);
	}

	return (
		<Box
			display="flex"
			flexDirection="column"
			bg="white"
			maxWidth="500px"
			paddingLeft={{ base: "20px", lg: "40px" }}
			paddingRight={{ base: "20px", lg: "40px" }}
			paddingTop={{ base: "20px", lg: "30px" }}
			paddingBottom={{ base: "20px", lg: "30px" }}
			rounded="md"
			shadow="md"
			gap={{ base: "10px", lg: "20px" }}
		>
			{
				isSubmitting ?
				<Center>
					<Spinner />
				</Center>
				:
				<>
					<Text
						className='poppins-semibold'
						fontSize="18px"
					>
						{t('pages.personalInformation.personalInformationDeletionBox.title')}
					</Text>
					<Text
						fontSize="14px"
					>
						{t('pages.personalInformation.personalInformationDeletionBox.description')}
					</Text>
					{
						userDeletionRequestIsPending &&
						<Alert status="info" title={t('pages.personalInformation.personalInformationDeletionBox.actions.delete.pending')} />
					}
					<Button
						marginTop="10px"
						textWrap="wrap"
						onClick={handleUserDeletionRequest}
						disabled={hasActiveUserDeletionRequest}
					>
						{t('pages.personalInformation.personalInformationDeletionBox.actions.delete.label')}
					</Button>
				</>
			}

		</Box>
	)
}

export default PersonalInformationDeletionBox;
